import React, { createContext, useState, useContext, useEffect } from 'react';

import { MyContext } from '../ProviderContext';

export const Construction = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: 'active', team: '', contact: '', project: '' });
    }, [])

    return (

        <>
            <div className="page-header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Construction</h2>
                        </div>
                        <div className="col-12">
                            <a href="">Home</a>
                            <a href="">construction</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <img src='/img/construction-1.png' width='100%' />
                    </div>
                    <div className='col-6 about-text'>
                        <h3>Our Construction Services</h3>
                             <img src='/img/construction-2.png' width='100%' />
                         </div>
                </div>
               <div className='row'>
                <div className='col-6'>
                    <h3>Road & Building Construction</h3>
                    <img src='/img/construction-3.png' /></div>
                <div className='col-6'>
                <p>FRANTINO boasts of highly experienced and motivated construction team that gives attention to details, surpassing the client’s expectations; from the road construction planning, to setting out, earthworks, to paving etc. From building construction design and planning stage, to site preparation, foundation construction, superstructure construction, finishing, to inspection and handover stage. These attention to details comes with highest priority on safety and quality control at all our project work stages, from project startup to handover. </p>
                <img src='/img/construction-4.png' />
                </div>
               </div>
               <div className='row'>
                <div className='col-6'>
                    <img src='/img/fabrication-1.png' width='100%' />
                    <p>
                    Our Mechanical Engineers are proficient in Designing, Developing, Constructing, and testing various Mechanical Systems and Devices. We specialize in:
                    </p>

                    <p>
                    
                            <i className="fui-check"></i> Designing Mechanical Systems. <br />
                            <i className="fui-check"></i> Analyzing and Testing Designs. <br />
                            <i className="fui-check"></i> Project Management. <br />
                            <i className="fui-check"></i> Materials Selection. <br />
                            <i className="fui-check"></i> Construction of various Mechanical Systems
                            <br />
                            <i className="fui-check"></i> CAD Modeling and Drafting
                    </p>
                </div>
                <div className='col-6'>
                    <br />
                    <br />
                    <img src='/img/fabrication-2.png' width='100%' />
                   <h3> We specialize in following fabrication services:</h3>
                   <i className="fui-check"></i> Offshore and Onshore Fabrications (Jackets, Flare Booms, Structural Steel fabrications, Pipe Supports, Blasting & Painting, etc.) <br />
                   <i className="fui-check"></i> Sub-sea Structures (suction piles, Manifolds, Water injection, etc.) <br />
                   <i className="fui-check"></i> Surface Storage Tanks <br />
                   <i className="fui-check"></i> Power Plant Facilities <br />
                </div>
               </div>
            </div>
        </>
    )
}